import React, { useContext, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCaretDown, faXmark} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import ReportPrint from "./ReportPrint";
import RequestDataDeleteDialog from "./RequestDataDeleteDialog";
import InitContext from "../pages/InitContext";
import useMmcService from "../../services/MmcService";
import exampleRequest from "../../resources/json/healthLordRequestBodyExample.json";
//import exampleRequest from "../../resources/json/request_tomaz.json";
//import TestUploadButton from "../pages/TestUploadButton";

const NavigationBar = ({ onResetApp }) => {
  const { t } = useTranslation();
  const [showRequestDataDeleteDialog, setShowRequestDataDeleteDialog] = useState(false);

  const [pdmId, setPdmId] = useState(-1);
  const [showPdmIdDialog, setShowPdmIdDialog] = useState(false);
  const [hisOrderId, setHisOrderId] = useState("");
  const [showHisOrderDialog, setShowHisOrderDialog] = useState(false);

  const context = useContext(InitContext);
  const { login, sendHealthLordRequest, getHealthLordResults, getHisPdmReportFile } = useMmcService();

  const handleShowDeleteDataRequestDialog = () => {
    setShowRequestDataDeleteDialog(true);
  };

  const handleCancelRequestDataDelete = () => {
    setShowRequestDataDeleteDialog(false);
  };

  const handleRequestDataDeleteSubmitted = () => {
    setShowRequestDataDeleteDialog(false);
    onResetApp();
  };

  const handleSendHealthLordRequest = () => {
    const body = {
      name: "healthlord",
      password: "geheim"
    };

    login(body).then((token) => {
      sendHealthLordRequest(`bearer ${token?.token}`, exampleRequest).then();
    });
  };

  const handleGetHealthLordResults = () => {
    const body = {
      name: "healthlord",
      password: "geheim"
    };

    login(body).then((token) => {
      getHealthLordResults(`bearer ${token.token}`, hisOrderId).then((result) => {
        setHisOrderId("");
        setShowHisOrderDialog(false);
      });
    });
  };

  const handleGetHealthLordResultFile = () => {
    const body = {
      name: "healthlord",
      password: "geheim"
    };

    login(body).then((token) => {
      getHisPdmReportFile(`bearer ${token.token}`, pdmId).then((result) => {
        setPdmId(-1);
        setShowPdmIdDialog(false);

        if (result) {
          const url = window.URL.createObjectURL(result.blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = result.filename;
          document.body?.appendChild(a);
          a.click();
          a.remove();
        } else {
          console.log("handleGetHealthLordResultFile, PDM report not found");
        }
      });
    });
  };

  return (
    <div className="w3-bar w3-theme-l3 app-nav">
      <NavLink to={`/drugsTab/`}
               className={({ isActive }) => isActive
                  ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                  : "w3-bar-item w3-hover-light-blue app-nav-item"}>
        <label>{t("medication_plan")}</label>
      </NavLink>
      <div className="w3-dropdown-hover w3-theme-l3 app-nav-dropdown">
        <button className="w3-btn w3-theme-l3 w3-hover-light-blue app-nav-item">
          <label>{t("diary")}</label> <FontAwesomeIcon icon={faCaretDown} />
        </button>
        <div className="w3-dropdown-content w3-bar-block w3-theme-l3 w3-border app-nav-dropdown-content">
          <NavLink
            to={`/symptoms/`}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                : "w3-bar-item w3-hover-light-blue app-nav-item"
            }
          >
            <label>{t("symptoms")}</label>
          </NavLink>
          <NavLink
            to={`/labValues/`}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                : "w3-bar-item w3-hover-light-blue app-nav-item"
            }
          >
            <label>{t("lab_values")}</label>
          </NavLink>
          <NavLink
            to={`/measurements/`}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                : "w3-bar-item w3-hover-light-blue app-nav-item"
            }
          >
            <label>{t("measurements")}</label>
          </NavLink>
        </div>
      </div>
      <div className="w3-dropdown-hover w3-theme-l3 app-nav-dropdown">
        <button className="w3-btn w3-theme-l3 w3-hover-light-blue app-nav-item">
          <label>{t("medication_information")}</label>{" "}
          <FontAwesomeIcon icon={faCaretDown} />
        </button>
        <div className="w3-dropdown-content w3-bar-block w3-theme-l3 w3-border app-nav-dropdown-content">
          <NavLink
            to={`/pdir/`}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                : "w3-bar-item w3-hover-light-blue app-nav-item"
            }
          >
            <label>{t("medication_recommender")}</label>
          </NavLink>
          {context?.patient?.study_id?.toLowerCase() === "demo-hospital" && (
              <NavLink
                  to={`/pharmaOracle/`}
                  className={({ isActive }) =>
                      isActive
                          ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                          : "w3-bar-item w3-hover-light-blue app-nav-item"
                  }
              >
                <label>{t("pharma_oracle")}</label>
              </NavLink>
          )}
        </div>
      </div>
      <div className="w3-dropdown-hover w3-theme-l3 app-nav-dropdown">
        <button className="w3-btn w3-theme-l3 w3-hover-light-blue app-nav-item">
          <label>{t("profile")}</label> <FontAwesomeIcon icon={faCaretDown} />
        </button>
        <div className="w3-dropdown-content w3-bar-block w3-theme-l3 w3-border app-nav-dropdown-content">
          {
            <NavLink
              to={`/patient/`}
              className={({ isActive }) =>
                isActive
                  ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                  : "w3-bar-item w3-hover-light-blue app-nav-item"
              }
            >
              <label>{t("health")}</label>
            </NavLink>
          }
          <NavLink
            to={`/pgx/`}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                : "w3-bar-item w3-hover-light-blue app-nav-item"
            }
          >
            <label>{t("pgx")}</label>
          </NavLink>
          <button
            className="w3-bar-item w3-hover-light-blue w3-theme-l3 app-nav-item"
            onClick={() => {}}
          >
            <label>Ask AI</label>
          </button>
          <button
            className="w3-bar-item w3-hover-light-blue w3-theme-l3 app-nav-item"
            onClick={handleShowDeleteDataRequestDialog}
            disabled={context?.patient?.delete_requested === 1}
          >
            <label>{t("request_delete_my_data")}</label>
          </button>
          {/*<button
            className="w3-bar-item w3-hover-light-blue w3-theme-l3 app-nav-item fa-test-color"
            onClick={handleSendHealthLordRequest}
          >
            FaTest: Send HealthLord request
          </button>
            <TestUploadButton/>
            <button
            className="w3-bar-item w3-hover-light-blue w3-theme-l3 app-nav-item fa-test-color"
            onClick={() => setShowHisOrderDialog(true)}
        >
          FaTest: Get HealthLord results
        </button>
        <button className="w3-bar-item w3-hover-light-blue w3-theme-l3 app-nav-item fa-test-color"
                onClick={() => setShowPdmIdDialog(true)}>
          Get result file
        </button>
        */}
        </div>
      </div>
      <ReportPrint />
      {/*showPdmIdDialog && (
        <div className="feedback-modal">
          <div className="feedback-modal-content">
            <header className="feedback-modal-header">
              <h2>Enter the PDM ID</h2>
              <FontAwesomeIcon
                icon={faXmark}
                onClick={() => setShowPdmIdDialog(false)}
              />
            </header>
            <input
              type="text"
              value={pdmId}
              onChange={(e) => setPdmId(e.target.value)}
            />
            <div className="feedback-modal-buttons">
              <button onClick={handleGetHealthLordResultFile} className="w3-btn w3-round-xlarge w3-theme-d5">
                Retrieve PDF file
              </button>
              <button
                onClick={() => setShowPdmIdDialog(false)} className="w3-btn w3-round-xlarge w3-theme-d5">
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      )*/}
      {/*showHisOrderDialog && (
        <div className="feedback-modal">
          <div className="feedback-modal-content">
            <header className="feedback-modal-header">
              <h2>Enter the HIS order ID</h2>
              <FontAwesomeIcon
                icon={faXmark}
                onClick={() => setShowHisOrderDialog(false)}
              />
            </header>
            <input
              type="text"
              value={hisOrderId}
              onChange={(e) => setHisOrderId(e.target.value)}
              style={{ width: "40ch", padding: "8px", borderRadius: "4px" }}
            />
            <div className="feedback-modal-buttons">
              <button onClick={handleGetHealthLordResults} className="w3-btn w3-round-xlarge w3-theme-d5">
                Retrieve the results
              </button>
              <button
                onClick={() => setShowHisOrderDialog(false)} className="w3-btn w3-round-xlarge w3-theme-d5">
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      )*/}
      {showRequestDataDeleteDialog && (
        <RequestDataDeleteDialog
          showDialog={showRequestDataDeleteDialog}
          onConfirmRequestDataDelete={handleRequestDataDeleteSubmitted}
          onCancelRequestDataDelete={handleCancelRequestDataDelete}
        />
      )}
    </div>
  );
};

export default NavigationBar;
